if (!customElements.get('sa-floating-icons')) {
  class SaFloatingIcons extends HTMLElement {
    constructor() {
      super();
      this.handleScroll = this.handleScroll.bind(this);
      this.scrollToTop = this.scrollToTop.bind(this);
      this.toggleSocialMenu = this.toggleSocialMenu.bind(this);
      this.closeSocialMenu = this.closeSocialMenu.bind(this);
      this.handleOutsideClick = this.handleOutsideClick.bind(this);
      this.handleOrderClick = this.handleOrderClick.bind(this);
      this.ticking = false;
    }

    connectedCallback() {
      this.items = this.querySelectorAll('.sa-floating-icons__item');
      
      // Selectors based on updated DOM structure
      this.scrollToTopBtn = this.querySelector('[aria-label="Scroll to top"]');
      this.socialTrigger = this.querySelector('.sa-floating-icons__trigger');
      this.socialRow = this.querySelector('.sa-floating-icons__social-row');
      
      // The first icon (Contact/Order)
      this.orderBtn = this.querySelector('.sa-floating-icons__item:not(.sa-floating-icons__trigger):not([aria-label="Scroll to top"]):not(.sa-floating-icons__sub-item)');

      if (this.scrollToTopBtn) {
        this.scrollToTopBtn.addEventListener('click', this.scrollToTop);
      }

      if (this.orderBtn) {
        this.orderBtn.addEventListener('click', this.handleOrderClick);
      }

      if (this.socialTrigger && this.socialRow) {
        this.socialTrigger.addEventListener('click', this.toggleSocialMenu);
        document.addEventListener('click', this.handleOutsideClick);
      }

      window.addEventListener('scroll', this.handleScroll);
      // Check initial state
      this.checkScroll();
    }

    disconnectedCallback() {
      if (this.scrollToTopBtn) {
        this.scrollToTopBtn.removeEventListener('click', this.scrollToTop);
      }
      if (this.orderBtn) {
        this.orderBtn.removeEventListener('click', this.handleOrderClick);
      }
      if (this.socialTrigger) {
        this.socialTrigger.removeEventListener('click', this.toggleSocialMenu);
        document.removeEventListener('click', this.handleOutsideClick);
      }
      window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll() {
      if (!this.ticking) {
        window.requestAnimationFrame(() => {
          this.checkScroll();
          this.ticking = false;
        });
        this.ticking = true;
      }
    }

    checkScroll() {
      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;
      const docHeight = document.documentElement.scrollHeight;

      // Show when user has scrolled past the first screen (roughly 1 viewport height)
      // "划过差不多第一屏 就出现"
      const isPastFirstScreen = scrollTop > windowHeight;

      if (isPastFirstScreen) {
        this.classList.add('sa-floating-icons--visible');
      } else {
        this.classList.remove('sa-floating-icons--visible');
        // Close menu when hiding the floating icons
        this.closeSocialMenu();
      }
    }

    handleOrderClick(e) {
      if (e) {
        e.preventDefault();
      }
      
      // Call global openOrderDialog
      if (window.openOrderDialog && typeof window.openOrderDialog === 'function') {
        window.openOrderDialog({
          title: 'Talk to our team',
          description: 'Connect with our sales team to explore how our cutting-edge technology can empower your research today.',
          privacyUrl: '/pages/policy',
          termsUrl: '/pages/terms-of-use'
        });
      }
    }

    scrollToTop(e) {
      if (e) e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }

    toggleSocialMenu(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation(); // Prevent document click from closing it immediately
      }
      
      if (!this.socialTrigger) return;

      const isExpanded = this.socialTrigger.getAttribute('aria-expanded') === 'true';
      
      if (isExpanded) {
        this.closeSocialMenu();
      } else {
        this.openSocialMenu();
      }
    }

    openSocialMenu() {
      if (!this.socialRow || !this.socialTrigger) return;
      this.socialRow.classList.add('sa-floating-icons__social-row--visible');
      this.socialTrigger.setAttribute('aria-expanded', 'true');
    }

    closeSocialMenu() {
      if (!this.socialRow) return;
      this.socialRow.classList.remove('sa-floating-icons__social-row--visible');
      if (this.socialTrigger) {
        this.socialTrigger.setAttribute('aria-expanded', 'false');
      }
    }

    handleOutsideClick(e) {
      // If menu is open and click is outside the group wrapper
      if (!this.socialTrigger) return;
      const isExpanded = this.socialTrigger.getAttribute('aria-expanded') === 'true';
      if (!isExpanded) return;

      const groupWrapper = this.querySelector('.sa-floating-icons__group-wrapper');
      if (groupWrapper && !groupWrapper.contains(e.target)) {
        this.closeSocialMenu();
      }
    }
  }

  customElements.define('sa-floating-icons', SaFloatingIcons);
}
